<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>
            검색조건
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>교우명</th>
              <td>
               <input v-focus type="text" v-model="query.memberHnm" v-on:keyup.enter="searchQuery"/>
              <!-- <input v-focus type="text" @input="query.memberHnm = $event.target.value" v-on:keyup.enter="searchQuery"/> -->
              </td>
              <th>교우번호</th>
              <td>
                <input type="text" v-model="query.memberNo" v-on:keyup.enter="searchQuery"/>
              </td>
              <th>대학/통합단과대</th>
              <td>
                <div class="inline-flex">
                  <input type="text" readonly v-model="searchedCollegeName"/>
                  <button @click=" () => { this.isShowCollegeModal = true; }">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th>학과</th>
              <td>
                <div class="inline-flex">
                  <input type="text" disabled v-model="searchedClassName"/>
                  <button @click=" () => { this.isShowClassModal = true; }">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th>휴대폰</th>
              <td>
                <input type="text" v-model="query.cellular" v-on:keyup.enter="searchQuery" maxlength="13"/>
              </td>
            </tr>
            <tr>
              <th>생년월일</th>
              <td>
                <input type="text" v-model="query.birthday" v-on:keyup.enter="searchQuery" v-mask="'####-##-##'"/>
              </td>
              <th>성별</th>
              <td>
                <label>
                  <input type="radio" value="" v-model="query.sex" v-on:keyup.enter="searchQuery"/>전체
                </label>
                <label>
                  <input type="radio" value="M" v-model="query.sex" v-on:keyup.enter="searchQuery"/>남
                </label>
                <label>
                  <input type="radio" value="F" v-model="query.sex" v-on:keyup.enter="searchQuery"/>여
                </label>
              </td>
              <th>국적</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="searchedNationalName" disabled />
                  <button @click=" () => { this.isShowNationModal = true; }">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th>출신고교</th>
              <td>
                <input type="text" v-model="query.highschool" v-on:keyup.enter="searchQuery"/>
              </td>
              <th>교원구분</th>
              <td>
                <div class="inline-flex">
                  <select v-model="query.selectedStaffType">
                    <option label="교원 아님" value=""></option>
                    <option v-for="item in staffTypeList" :key="item.code" :label="item.codeNm" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                  <!--<label><input type="checkbox" />교원여부</label>-->
                </div>
              </td>
            </tr>
            <tr>
              <th>학번</th>
              <td>
                <input type="text" v-model="query.hakbun" v-on:keyup.enter="searchQuery"/>
              </td>
              <th>입학년월</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-mask="'####-##'" v-model="query.enterYm" v-on:keyup.enter="searchQuery"/>
                </div>
              </td>
              <th>졸업년월</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-mask="'####-##'" v-model="query.graduationYm" v-on:keyup.enter="searchQuery"/>
                </div>
              </td>
              <th>직종</th>
              <td>
                <div class="inline-flex">
                  <input type="text" disabled v-model="searchedWorkName1" />
                  <button @click=" () => { this.isShowWorkModal1 = true; }">
                    <md-icon>search</md-icon>
                  </button>
                  <input type="text" disabled v-model="searchedWorkName2" />
                  <button @click="() => { this.isShowWorkModal2 = true; }">
                    <md-icon>search</md-icon>
                  </button>
                </div>
              </td>
              <th>직장명</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="searchedCompanyName" v-on:keyup.enter="searchQuery"/>
                  <button @click="checkCompanyPop">
                    <md-icon>search</md-icon>
                  </button>
                  <input type="text" placeholder="직장직위" v-model="query.levelNm" v-on:keyup.enter="searchQuery"/>
                </div>
              </td>
            </tr>
            <tr>
              <th>이메일</th>
              <td>
                <input type="text" v-model="query.eMail" v-on:keyup.enter="searchQuery"/>
              </td>
              <th>지역</th>
              <td>
                <div class="inline-flex">
                  <label>
                    <input type="checkbox" v-model="isCheckedHomeZipcd" @change="checkHome" />자택
                  </label>
                  <label>
                    <input type="checkbox" v-model="isCheckedOfficeZipcd" @change="checkOffice" />직장
                  </label>

                  <select v-model="selectedSiDo" @change="changeAddrSiDo">
                    <option label="선택" value=""></option>
                    <option v-for="item in addrSiDoList" :key="item.code" :label="item.codeNm+' ['+item.etcMeta1+' ~ '+item.etcMeta2+' ]'" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                  <select v-model="selectedGunGu" @change="changeAddrGunGu">
                    <option label="선택" value=""></option>
                    <option v-for="item in addrGunGuList" :key="item.code" :label="item.codeNm+' ['+item.etcMeta1+' ~ '+item.etcMeta2+' ]'" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                </div>
              </td>
              <th>회원등급</th>
              <td>
                <div class="inline-flex">
                  <select v-model="query.mlevelCd">
                    <option label="선택" value=""></option>
                    <option v-for="item in memberLevelTypeList" :key="item.code" :label="item.codeNm" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                </div>
              </td>
              <th>회비등급</th>
              <td>
                <div class="inline-flex">
                  <select v-model="query.feeLevelCd">
                    <option label="선택" value=""></option>
                    <option v-for="item in feeCdTypeList" :key="item.code" :label="item.codeNm" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                </div>
              </td>
              <th>학위구분</th>
              <td>
                <div class="inline-flex">
                  <select v-model="query.degreeCd">
                    <option label="선택" value=""></option>
                    <option v-for="item in degreeCdTypeList" :key="item.code" :label="item.codeNm" :value="item.code">
                      {{ item }}
                    </option>
                  </select>
                </div>
              </td>
            </tr>
          </table>
        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="searchQuery">
            <md-icon>check</md-icon>검 색
          </md-button>
          <md-button class="md-default md-sm" @click="clearQuery">
            <md-icon>clear</md-icon>초기화
          </md-button>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
        </md-card-actions>
      </md-card>

      <!-- 목록 시작 -->
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>list</md-icon>
            검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change.prevent="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <grid ref="executivesGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @dblclick="onDbClickExecutive"
                @response="response"></grid>
        </md-card-content>
      </md-card>
    </div>

    <!-- --------------------------- Modal Popup --------------------------------------->
    <div>
      <!--대학선택 팝업 -->
      <college-search-pop-comp ref="collegeSearchPopup" :is-show.sync="isShowCollegeModal" @returnResult="callbackCollege"></college-search-pop-comp>

      <!--학과선택 팝업 -->
      <class-search-pop-comp :is-show.sync="isShowClassModal" :l-code-cd="query.lCodeCd" :m-code-cd="query.collegeCd" @returnResult="callbackClass"></class-search-pop-comp>

      <!--직종선택 팝업 -->
      <work-search-pop-comp1 :is-show.sync="isShowWorkModal1" @returnResult="callbackWork1"></work-search-pop-comp1>
      <work-search-pop-comp2 :is-show.sync="isShowWorkModal2" :l-code-cd.sync="query.workCd1" @returnResult="callbackWork2"></work-search-pop-comp2>

      <!--직장선택 팝업 -->
      <company-search-pop-comp :is-show.sync="isShowCompanyModal" :l-code-cd.sync="query.workCd1" :m-code-cd.sync="query.workCd2" :searchText.sync="this.searchedCompanyName" @returnResult="callbackCompany"></company-search-pop-comp>

      <!--국가선택 팝업 -->
      <nation-search-pop-comp :is-show.sync="isShowNationModal" @returnResult="callbackNation"></nation-search-pop-comp>

    </div>
    <!-- --------------------------- Modal Popup --------------------------------------->
  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import { WorkSearchPopComp1, WorkSearchPopComp2, CompanySearchPopComp, CollegeSearchPopComp, ClassSearchPopComp, NationSearchPopComp } from "@/pages"
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaApi from "@/kuaa/kuaa-api";
//import Pagination from 'tui-pagination';
import axios from "axios";

import Swal from "sweetalert2";

export default {
  components: {
    grid: Grid,
    WorkSearchPopComp1,
    WorkSearchPopComp2,
    CompanySearchPopComp,
    CollegeSearchPopComp,
    ClassSearchPopComp,
    NationSearchPopComp
  },

  created() {
    this.initGrid();
    this.searchStaffTypes();
    this.searchAddrSiDoList();
    this.searchMemberLevelTypes();
    this.searchFeeCdTypes();
    this.searchDegreeCdTypes();
  },

  computed: {
    total() {
      return this.pagination.total;
    },

    checkedHomeZipcd: {
      get() {
        return this.isCheckedHomeZipcd;
      },
      set(bool) {
//        this.query.homeZipYn = bool ? this.inputZipcd : "";
        this.isCheckedHomeZipcd = bool;
      }
    },
    checkedOfficeZipcd: {
      get() {
        return this.isCheckedOfficeZipcd;
      },
      set(bool) {
  //      this.query.officeZipYn = bool ? this.inputZipcd : "";
        this.isCheckedOfficeZipcd = bool;
      }
    }
  },

  data() {
    return {
      formatter,
      // 교원 종류 선택
      staffTypeList: [],

      // 회원등급 선택
      memberLevelTypeList: [],

      // 회비등급 선택
      feeCdTypeList: [],

      // 학위구분 선택
      degreeCdTypeList: [],

      // 국가선택
      searchedNationalName: "",
      isShowNationModal: false,

      // 직종 검색
      searchedWorkName1: "",
      isShowWorkModal1: false,

      searchedWorkName2: "",
      isShowWorkModal2: false,

      // 직장명 검색
      searchedCompanyName: "",
      isShowCompanyModal: false,

      // 대학 선택 데이터
      searchedCollegeName: "",
      isShowCollegeModal: false,

      // 학과 선택 데이터
      searchedClassName: "",
      isShowClassModal: false,

      currentSort: "name",
      currentSortOrder: "asc",

      pagination: {
        perPage: 100,
        page: 1,
        perPageOptions: [100, 200, 500, 1000, 2000],
        total: 0
      },
      propsToSearch: ["name", "email", "age"],

      query: {
        memberHnm: "",
        memberNo: "",
        cellular: "",
        eMail: "",
        birthday: "",
        sex: "",
        nationalCd: "",
        highschool: "",
        // 학사구분
        // 교원구분
        hakbun: "",
        lCodeCd: "",
        collegeCd: "", // 공통코드 검색 후 assign
        classCd: "",
        enterYm: "",
        graduationYm: "",
        companyNm: "",
        companyId: "", // 직종 공통코드 검색 후 assign
        addressGb: "",
        homeZipYn: "N",
        officeZipYn: "N",
        addrZipFromToCd: "",
        mlevelCd: "",  // 회원등급
        feeLevelCd: "",  // 회비등급
        degreeCd: "",  // 학위구분
        levelNm: "",
        selectedStaffType: ""
      },
      enterYear: "",
      enterMonth: "",
      graduationYear: "",
      graduationMonth: "",
      inputTextZipcd: "",
      isCheckedHomeZipcd: false,
      isCheckedOfficeZipcd: false,
      selectedSiDo: "",
      selectedGunGu: "",

      addrSiDoList:[],
      addrGunGuList:[]
    };
  },

  methods: {
    /**
     * 검색 조건 초기화
     */
    clearQuery() {
      this.$refs.collegeSearchPopup.clearQuery();

      this.query = {
        memberHnm: "",
        memberNo: "",
        cellular: "",
        eMail: "",
        birthday: "",
        sex: "",
        nationalCd: "",
        highschool: "",
        // 학사구분
        // 교원구분
        hakbun: "",
        collegeCd: "", // 공통코드 검색 후 assign
        classCd: "",
        enterYm: "",
        graduationYm: "",
        companyNm: "",
        companyId: "", // 직종 공통코드 검색 후 assign
        addressGb: "",
        zipCd: "",
        homeZipYn: "N",
        officeZipYn: "N",
        addrZipFromToCd: "",
        mlevelCd: "",  // 회원등급
        feeLevelCd: "",  // 회비등급
        degreeCd: "",  // 학위구분
        workCd1: "",
        workCd2: "",
        levelNm: "",
        selectedStaffType: ""
      };
      this.searchedCompanyName = "";
      // this.searchedCompanyCd = "";
      this.searchedWorkName1 = "";
      this.searchedWorkName2 = "";
      this.workCd1 = "";
      this.workCd2 = "";
      this.enterYear = "";
      this.enterMonth = "";
      this.graduationYear = "";
      this.graduationMonth = "";
      this.searchedCollegeName = "";
      this.searchedClassName = "";
      this.searchedNationalName = "";
      this.inputTextZipcd = "";
      this.isCheckedHomeZipcd = false;
      this.isCheckedOfficeZipcd = false;
      this.selectedSiDo = "";
      this.selectedGunGu = "";
    },

    onClickMember(item) {
      location.href = "/Friendship/UpdateMember/" + item.memberNo;
    },

    searchQuery() {
      this.doSearch();
    },

    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.executivesGrid, event, this.pagination);
    },

    doSearch() {
      if(this.query.homeZipYn == 'Y' || this.query.officeZipYn == 'Y'){
        if(!this.query.addrZipFromToCd){
          kuaaFnc.showSwal("지역 선택", '시도 또는 군구를 선택해 주세요.');
          return false;
        }
      };
      if(this.query.addrZipFromToCd){
        if(this.query.homeZipYn != 'Y' && this.query.officeZipYn != 'Y'){
          kuaaFnc.showSwal("지역 선택", '자택 또는 직장을 선택해 주세요.');
          return false;
        }
      };
      
      // 직장명이 있는 경우
      let tmpCompanyNm = this.query.companyNm;
      let tmpWorkCd1   = this.query.workCd1;
      let tmpWorkCd2   = this.query.workCd2;

      if(this.query.companyId.trim() && this.searchedCompanyName.trim()){
        this.query.companyNm = '';
      };

      if(!this.query.companyId.trim() && this.searchedCompanyName.trim()){
        this.query.companyNm = this.searchedCompanyName.trim();
        tmpCompanyNm = this.query.companyNm;
        this.query.workCd1 = '';
        this.query.workCd2 = '';
      }

      let params = JSON.parse(JSON.stringify(this.query));
    
      params['birthday'] = kuaaFnc.cleanDateFormatter(params['birthday']);
      //params['cellular'] = formatter.getPhoneMask(this.query.cellular);
      this.$refs.executivesGrid.invoke("readData", 1, params, true);

      this.query.companyNm = tmpCompanyNm;
      this.query.workCd1 = tmpWorkCd1;
      this.query.workCd2 = tmpWorkCd2;
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_MEMBER_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.executivesGrid;
      this.gridProps['columns']= [
        {header: '교우번호', name: 'memberNo', align:"center", width:70, sortable: true,
          formatter(value) {
            return `<span style="color:#0091d5; text-decoration:underline; cursor:pointer">${value.value}</span>`;
          }
        },
        {header: '교우명', name: 'memberHnm', width:100, sortable:true},
        {header: '교우직위', name: 'memberorgGbNm', width:100, align:"center", sortable: true},
        {header: '성별', name: 'sex', align:"center", sortable: true},
        {header: '생년월일', name: 'birthday', width:80, align:"center", sortable: true,
          formatter(value) {
            return (value.value && value.value.length == 8) ? formatter.getDateFormat(value.value) : value.value;
          }
        },
        {header: '대학명', name: 'collegeCdNm', width:120, align:"center", sortable: true},
        {header: '학과명', name: 'classCdNm', width:120, sortable: true},
        {header: '학번', name: 'hakbun', width:100, align:"center", sortable: true},
        {header: '졸업회수', name: 'graduationNo', width:80, align:"center", sortable: true},
        {header: '입학년월', name: 'enterYm', width:80, align:"center", sortable: true,
          formatter(value) {
            return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
          }
        },
        {header: '졸업년월', name: 'graduationYm', width:80, align:"center", sortable: true,
          formatter(value) {
            return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
          }
        },
        {header: '학위', name: 'degreeCdNm', width:100, align:"center", sortable: true},
        {header: '직장명', name: 'companyNm', width:120, sortable: true},
        {header: '부서', name: 'partNm', width:100, sortable: true, align:"center"},
        {header: '직위', name: 'levelNm', width:100, sortable: true, align:"center"},
        {header: '핸드폰번호', name: 'cellular', width:100, align:"center", sortable: true},
        {header: '이메일', name: 'eMail', width:150, sortable: true},
        {header: '평생회비납부이력', name: 'memberGbNm', width:120, align:"center", sortable: true},
        {header: '최종납입년도', name: 'lastFeeYear', width:110, align:"center", sortable: true},
        {header: '납부년월일', name: 'lastFeeDate', width:100, align:"center", sortable: true},
        {header: '자택우편번호', name: 'homeZipcd', width:110, align:"center", sortable: true},
        {header: '자택주소1', name: 'homeAddress1', width:"auto", sortable: true},
        {header: '자택주소2', name: 'homeAddress2', width:"auto", sortable: true},
        {header: '자택전화', name: 'homeTel', width:100, align:"center", sortable: true},
        {header: '직장우편번호', name: 'officeZipcd', width:110, align:"center", sortable: true},
        {header: '직장주소1', name: 'officeAddress1', width:"auto", sortable: true},
        {header: '직장주소2', name: 'officeAddress2', width:"auto", sortable: true},
        {header: '직장전화번호', name: 'officeTel', width:100, align:"center", sortable: true},
        {header: '직종1', name: 'workCd1Nm', width:100, sortable: true},
        {header: '직종2', name: 'workCd2Nm', width:100, sortable: true},
        {header: '국적', name: 'nationalCdNm', width:100, align:"center", sortable: true},
        {header: '출신고교', name: 'highschool', width:100, align:"center", sortable: true},
        {header: '교원구분', name: 'staffCdNm', width:100, align:"center", sortable: true},
        {header: '회원등급', name: 'mlevelNm', width:100, align:"center", sortable: true},
        {header: '회비등급', name: 'feeLevelCdNm', align:"center", width:80, sortable: true},
        {header: '발송구분', name: 'postplaceNm', align:"center", width:80, sortable: true},
        {header: '미발송사유', name: 'nonpostGbNm', width:100, align:"center", sortable: true},
        {header: '휴대폰공개거부', name: 'cellularDeny', width:120, align:"center", sortable: true},
        {header: '이메일1공개거부', name: 'eMailDeny', width:120, align:"center", sortable: true},
        {header: '자택공개거부', name: 'homeAddressDeny', width:100, align:"center", sortable: true},
        {header: '직장공개거부', name: 'officeAddressDeny', width:100, align:"center", sortable: true}
      ];
      this.gridProps['columnOptions'].frozenCount = 4;
      this.gridProps['theme'].name = 'default';
      this.gridProps['theme'].value.row = null;
    },

    response(e) {
      let _this = this;
      
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
        this.$refs.executivesGrid.invoke("setPaginationTotalCount", res.data.pagination.totalCount);

        setTimeout(function () {
          let rows = _this.$refs.executivesGrid.invoke("getData");
          let cssArr = ['green-50', 'white'];
          let prevRowMemberNo = null;
          let rowCss = cssArr[0];
          rows.forEach((obj)=>{
//console.log(prevRowMemberNo);            
            if(prevRowMemberNo != obj.memberNo){
              prevRowMemberNo = obj.memberNo;
              rowCss = rowCss == cssArr[0]? cssArr[1] : cssArr[0];
            }
            _this.$refs.executivesGrid.invoke("addRowClassName",obj.rowKey, rowCss);
          });
        },100)
        this.$refs.executivesGrid.invoke("refreshLayout");

      }else{
        kuaaFnc.gridErrorCallback(e,"교우조회");
      }
    },

    /**
     * 임원단 목록에서 특정 임원이 클릭됨
     * 아래쪽 임원 영역에 세팅 해 줌
     */
    onDbClickExecutive(e) {
      if(e.columnName === "memberNo" && e.instance.getRow(e.rowKey) != null) {

	  	  this.$emit('setExcutiveData', e.instance.getRow(e.rowKey));
	  	  window.open('/Friendship/UpdateMember/' + e.instance.getRow(e.rowKey).memberNo, 'FriendshipUpdateMember');
	  	  //this.$router.push({ name: '교우 관리 상세', params: { memberNo: e.instance.getRow(e.rowKey).memberNo, printingGb:e.instance.getRow(e.rowKey).printingGb }});
      }
    },

    /**
     * 직종 검색
     */
    callbackWork1(result) {
      if(result && result.code){
        if(this.query.workCd1 != result.code && this.query.workCd2){
          this.searchedWorkName2 = "";
          this.query.workCd2 = "";
        }
        this.searchedWorkName1 = result.codeNm;
        this.query.workCd1 = result.code;
      }
    },
    
    callbackWork2(result) {
      if(result && result.code){
        this.searchedWorkName2 = result.codeNm;
        this.query.workCd2 = result.code;
        this.query.workCd1 = result.lCodeCd;
        this.searchedWorkName1 = result.lCodeNm;
      }
    },
    
    /**
     * 직장명 검색
     */
    callbackCompany(result) {
      if(result && result.codeNm) {
        this.searchedCompanyName = result.codeNm;
        this.query.companyNm = result.codeNm;
        this.query.companyId = result.code;

        this.searchedWorkName2 = result.mCodeNm;
        this.query.workCd2 = result.mCodeCd;
        this.query.workCd1 = result.lCodeCd;
        this.searchedWorkName1 = result.lCodeNm;
      }
    },

    /**
     * 대학 검색
     */
    callbackCollege(result) {
      this.searchedCollegeName = result.codeNm;
      this.query.lCodeCd = result.lCodeCd;
      this.query.collegeCd = result.code;
      this.searchedClassName = "";
    },

    /**
     * 학과 검색
     */
    callbackClass(result) {
      this.searchedClassName = result.codeNm;
      this.query.classCd = result.code;
      this.searchedCollegeName = result.mCodeNm;
      this.query.collegeCd = result.mCodeCd;
    },

    checkCompanyPop(){
      if(this.query.workCd1 || this.query.workCd2){
        kuaaFnc.showSwal("직장 선택", "직종과 함께 검색할 수 없습니다<br>검색조건 초기화 후에 다시 선택해 주세요");
        return false;
      }
      this.isShowCompanyModal = true;
    },
    
    callbackNation(result) {
      this.searchedNationalName = result.codeNm;
      this.query.nationalCd = result.code;
    },

    /**
     * 교원 구분 - 공통코드 조회 세팅
     */
    searchStaffTypes() {
      kuaaFnc.fncStaffTypes(null,res => {
        this.staffTypeList = res.data.data.contents;
      });
    },

    /**
     * 회원등급 - 공통코드 조회 세팅
     */
    searchMemberLevelTypes() {
      kuaaFnc.fncMemberLevelTypes(null,res => {
        this.memberLevelTypeList = res.data.data.contents;
      });
    },

    /**
     * 회비등급 - 공통코드 조회 세팅
     */
    searchFeeCdTypes() {
      kuaaFnc.fncFeeLevelCdTypes(null,res => {
        this.feeCdTypeList = res.data.data.contents;
      });
    },

    /**
     * 학위구분 - 공통코드 조회 세팅
     */
    searchDegreeCdTypes() {
       kuaaFnc.fncDegreeCdTypes(null,res => {
         this.degreeCdTypeList = res.data.data.contents;              
       });
    },


    /**
     * 주소 시도 목록 - 공통코드 조회 세팅
     */
    searchAddrSiDoList() {
      kuaaFnc.fncAddrSiDoTypes(null,res => {
        this.addrSiDoList = res.data.data.contents;
//        this.selectedSiDo = "";
      });
    },

    /**
     * 주소 시도 변경시
     */
    changeAddrSiDo(e) {
      if(this.selectedSiDo) {
        this.selectedGunGu = "";
        this.query.addrZipFromToCd = JSON.parse(e.target.options[e.target.selectedIndex].text).etcMeta1 + JSON.parse(e.target.options[e.target.selectedIndex].text).etcMeta2;
        
        kuaaFnc.fncAddrGunGuTypes(this.selectedSiDo, null,res => {
          this.addrGunGuList = res.data.data.contents;
        });
      }
    },

    /**
     * 주소 시군구 변경시
     */
    changeAddrGunGu(e) {
      if(this.selectedGunGu) {
        this.query.addrZipFromToCd = JSON.parse(e.target.options[e.target.selectedIndex].text).etcMeta1 + JSON.parse(e.target.options[e.target.selectedIndex].text).etcMeta2;
      }
    },

    /**
     * 집 체크 변경시
     */
    checkHome(e) {
      if (this.isCheckedHomeZipcd && this.isCheckedOfficeZipcd) {
        this.query.homeZipYn = 'Y';
        this.query.officeZipYn = 'Y';
      } else if (this.isCheckedHomeZipcd) {
        this.query.homeZipYn = 'Y';
        this.query.officeZipYn = "N";
      } else if (this.isCheckedOfficeZipcd) {
        this.query.homeZipYn = "N";
        this.query.officeZipYn = 'Y';
      } else {
        this.query.homeZipYn = "N";
        this.query.officeZipYn = "N";
      }
    },

    /**
     * 직장 체크 변경시
     */
    checkOffice(e) {
      if (this.isCheckedHomeZipcd && this.isCheckedOfficeZipcd) {
        this.query.homeZipYn = 'Y';
        this.query.officeZipYn = 'Y';
      } else if (this.isCheckedHomeZipcd) {
        this.query.homeZipYn = 'Y';
        this.query.officeZipYn = "N";
      } else if (this.isCheckedOfficeZipcd) {
        this.query.homeZipYn = "N";
        this.query.officeZipYn = 'Y';
      } else {
        this.query.homeZipYn = "N";
        this.query.officeZipYn = "N";
      }
    },

    downloadExcel() {
      if(this.pagination.total > 100000){
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드 대상은 100,000건 이하여야 합니다.");
        return false;
      }
      let tmpCompanyNm = this.query.companyNm;
      let tmpWorkCd1   = this.query.workCd1;
      let tmpWorkCd2   = this.query.workCd2;

      if(!this.query.companyId.trim() == '' || !this.searchedCompanyName.trim() == ''){
        if(!this.query.companyId.trim() == '')  this.query.companyNm = '';
        this.query.workCd1 = '';
        this.query.workCd2 = '';
      };
      
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '교우관리';
      kuaaApi.requestFileDownload(
          URL_CONST.MEMBER_EXCEL_DOWNLOAD,
          this.query,
          '교우관리.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;

            this.query.companyNm = tmpCompanyNm;
            this.query.workCd1 = tmpWorkCd1;
            this.query.workCd2 = tmpWorkCd2;
          }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
